// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   SuiviDeCommandeBCV2 — feuille de style UNIQUE de la vue prestataire commande-bc.
   Copie autonome (PAS un import) du CSS de la case acheteur operation-bc :
   tout est porte par la racine .scbc (namespace miroir de .opbc), pour une parite
   visuelle exacte avec operation-bc sans fuite globale ni dependance accidentelle.
   Les feuilles lourdes reutilisees (ConsultationBC, OperationConsultationBC,
   CompteARebourd) conservent leur propre CSS — la frontiere est au niveau du
   contenu des onglets, exactement comme cote acheteur.
   ============================================================================= */

/* --- Layout page ---------------------------------------------------------- */
.scbc {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.scbc__content {
  padding: 0 6rem 2rem 6rem;
}

.scbc__tab-content {
  padding: 2rem 0;
  min-height: 500px;
}

@media print {
  .scbc__tab-content {
    padding: 0;
  }
}

/* --- Etats chargement / erreur / vide ------------------------------------- */
.scbc__loading,
.scbc__empty,
.scbc__error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.8rem;
  color: #374151;
  text-align: center;
}

.scbc__error p {
  color: #dc2626;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}

/* --- Barre d'onglets ------------------------------------------------------ */
.scbc__tab-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
}

@media print {
  .scbc__tab-nav {
    margin-bottom: 0 !important;
  }
}

.scbc__tab-nav-left {
  display: flex;
  gap: 2rem;
}

.scbc__tab-button {
  position: relative;
  background: none;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  color: #6b7280;
  cursor: pointer;
}

.scbc__tab-button:hover {
  color: #2c3948;
}

.scbc__tab-button.active {
  color: #2c3948;
  font-weight: 500;
}

.scbc__tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #f97316;
}

.scbc__tab-button.inactive,
.scbc__tab-button.disabled {
  color: #a1a1aa;
  cursor: not-allowed;
  opacity: 0.6;
}

.scbc__tab-button.inactive::after,
.scbc__tab-button.disabled::after {
  display: none;
}

.scbc__tab-button.inactive::before,
.scbc__tab-button.disabled::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  padding: 5px 10px;
  background-color: #333333;
  color: #ffffff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 1.2rem;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  z-index: 100;
}

.scbc__tab-button.inactive:hover::before,
.scbc__tab-button.disabled:hover::before {
  opacity: 1;
  visibility: visible;
}

/* --- Onglets non implementes ---------------------------------------------- */
.scbc__placeholder {
  padding: 2rem;
  font-size: 1.6rem;
  color: #6b7280;
}

/* Accordeons de section : corps colle aux bords, scope a la case v2 uniquement
   (ne touche pas le composant partage AnalyseAccordion utilise par MS). */
.scbc .analyse-accordion-body {
  padding: 0;
}

/* Pas de vide en bas : le dernier element du corps colle au bord de l'accordeon. */
.scbc .analyse-accordion-body > *:last-child,
.scbc .analyse-accordion-body .section-content > *:last-child {
  margin-bottom: 0;
}

/* Table financiere : on garde le layout auto d'origine (les largeurs .article-*
   en % restent respectees, colonnes alignees, hauteurs normales). On absorbe
   juste le leger debordement (paddings des cellules) en masquant la scrollbar
   horizontale residuelle, et on laisse un code trop long casser plutot que
   d'etre coupe. Scope a la case v2. */
.scbc .articles-table-wrapper {
  overflow-x: hidden;
}

.scbc .articles-table-wrapper th,
.scbc .articles-table-wrapper td {
  overflow-wrap: break-word;
}

/* Alignement coherent en-tete + contenu, force par colonne : les MEMES regles
   s'appliquent au thead et au tbody, donc l'en-tete ne peut pas se desynchroniser
   du contenu, et ca surclasse la regle globale qui forcait les en-tetes a gauche.
   Vaut pour la table read-only (6 colonnes) comme editable (7 colonnes, +Actions).
   col1 N°Ref + col2 Description = gauche ; col3 Unite + col4 Quantite + col7
   Actions = centre ; col5 Prix + col6 Total = droite. */
.scbc .articles-table-wrapper th:nth-child(1),
.scbc .articles-table-wrapper td:nth-child(1),
.scbc .articles-table-wrapper th:nth-child(2),
.scbc .articles-table-wrapper td:nth-child(2) {
  text-align: left;
}

.scbc .articles-table-wrapper th:nth-child(3),
.scbc .articles-table-wrapper td:nth-child(3),
.scbc .articles-table-wrapper th:nth-child(4),
.scbc .articles-table-wrapper td:nth-child(4),
.scbc .articles-table-wrapper th:nth-child(7),
.scbc .articles-table-wrapper td:nth-child(7) {
  text-align: center;
}

.scbc .articles-table-wrapper th:nth-child(5),
.scbc .articles-table-wrapper td:nth-child(5),
.scbc .articles-table-wrapper th:nth-child(6),
.scbc .articles-table-wrapper td:nth-child(6) {
  text-align: right;
  padding-right: 1rem;
}

/* Le bouton supprimer suit l'alignement centre de sa cellule (pas de flottant). */
.scbc .articles-table-wrapper td:nth-child(7) .delete-button {
  float: none;
  margin: 0 auto;
}

/* Spinner de suppression : remplace la croix, meme taille (1em) et meme couleur. */
.scbc .delete-spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: scbc-delete-spin 0.6s linear infinite;
  vertical-align: middle;
}

@keyframes scbc-delete-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Bouton "Ajouter ou modifier un article" : ne deborde plus a droite du wrapper
   (il porte une marge de 1rem de chaque cote -> largeur bornee a 100% - 2rem). */
.scbc .articles-table-wrapper .add-article-button {
  box-sizing: border-box;
  max-width: calc(100% - 2rem);
}

/* =============================================================================
   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .scbc-sk, geometrie
   calee sur le vrai rendu (banniere SuiviHeader + onglets + contenu) pour eviter le saut.
   ============================================================================= */
@keyframes scbc-sk-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.scbc-skeleton {
  pointer-events: none;
}

.scbc-sk {
  display: block;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: scbc-sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}

/* Banniere : meme geometrie que SuiviHeader (.suivi-commande-title : padding 2rem 4rem,
   marge basse 2rem, fond sombre) pour une hauteur identique au vrai header. */
.scbc-sk-banner {
  padding: 2rem 4rem;
  margin-bottom: 2rem;
  background: #1f2937;
}

/* Sur fond sombre, les blocs shimmer sont clairs. */
.scbc-sk-banner .scbc-sk {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);
  background-size: 200% 100%;
}

.scbc-sk-back { padding: 1rem 0; }
.scbc-sk-back .scbc-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }

.scbc-sk-h1 { height: 4.1rem; display: flex; align-items: center; }
.scbc-sk-h1 .scbc-sk { width: 45%; height: 2.4rem; }

.scbc-sk-h2 { height: 3.1rem; display: flex; align-items: center; }
.scbc-sk-h2 .scbc-sk { width: 32%; height: 1.8rem; }

.scbc-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }
.scbc-sk-subtitle .scbc-sk { width: 38%; height: 1.4rem; }

.scbc-sk-statusline { height: 2rem; display: flex; align-items: center; }
.scbc-sk-statusline .scbc-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }

/* Barre d'onglets : mime .scbc__tab-nav (border-bottom, marge basse 3rem). */
.scbc-sk-tabs {
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem 0;
  margin-bottom: 3rem;
}
.scbc-sk-tab { width: 80px; height: 1.6rem; }

/* Contenu : empilement de blocs (le padding horizontal/vertical vient de .scbc__tab-content). */
.scbc-sk-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.scbc-sk-block { width: 100%; height: 90px; }
.scbc-sk-block--lg { height: 220px; }

/* Badge de messages non-lus (onglet Messagerie). Pastille orange compacte collee au libelle. */
.scbc__tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
  height: 1.8rem;
  margin-left: 0.6rem;
  padding: 0 0.5rem;
  border-radius: 999px;
  background-color: #f97316;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeBCV2/SuiviDeCommandeBCV2.css"],"names":[],"mappings":"AAAA;;;;;;;;kFAQkF;;AAElF,+EAA+E;AAC/E;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,+EAA+E;AAC/E;;;EAGE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;0EAC0E;AAC1E;EACE,UAAU;AACZ;;AAEA,mFAAmF;AACnF;;EAEE,gBAAgB;AAClB;;AAEA;;;;sCAIsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;wDAKwD;AACxD;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;EAIE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,mFAAmF;AACnF;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;iFACiF;AACjF;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;;kFAGkF;AAClF;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,+HAA+H;EAC/H,0BAA0B;AAC5B;;AAEA,gBAAgB,eAAe,EAAE;AACjC,gCAAgC,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEnF,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,oBAAoB,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC7F,6BAA6B,UAAU,EAAE,cAAc,EAAE;;AAEzD,sBAAsB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACxE,+BAA+B,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAElF,6EAA6E;AAC7E;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA,eAAe,WAAW,EAAE,cAAc,EAAE;;AAE5C,gGAAgG;AAChG;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,qBAAqB,aAAa,EAAE;;AAEpC,+FAA+F;AAC/F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":["/* =============================================================================\n   SuiviDeCommandeBCV2 — feuille de style UNIQUE de la vue prestataire commande-bc.\n   Copie autonome (PAS un import) du CSS de la case acheteur operation-bc :\n   tout est porte par la racine .scbc (namespace miroir de .opbc), pour une parite\n   visuelle exacte avec operation-bc sans fuite globale ni dependance accidentelle.\n   Les feuilles lourdes reutilisees (ConsultationBC, OperationConsultationBC,\n   CompteARebourd) conservent leur propre CSS — la frontiere est au niveau du\n   contenu des onglets, exactement comme cote acheteur.\n   ============================================================================= */\n\n/* --- Layout page ---------------------------------------------------------- */\n.scbc {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.scbc__content {\n  padding: 0 6rem 2rem 6rem;\n}\n\n.scbc__tab-content {\n  padding: 2rem 0;\n  min-height: 500px;\n}\n\n@media print {\n  .scbc__tab-content {\n    padding: 0;\n  }\n}\n\n/* --- Etats chargement / erreur / vide ------------------------------------- */\n.scbc__loading,\n.scbc__empty,\n.scbc__error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.8rem;\n  color: #374151;\n  text-align: center;\n}\n\n.scbc__error p {\n  color: #dc2626;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n}\n\n/* --- Barre d'onglets ------------------------------------------------------ */\n.scbc__tab-nav {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n@media print {\n  .scbc__tab-nav {\n    margin-bottom: 0 !important;\n  }\n}\n\n.scbc__tab-nav-left {\n  display: flex;\n  gap: 2rem;\n}\n\n.scbc__tab-button {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.4rem;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.scbc__tab-button:hover {\n  color: #2c3948;\n}\n\n.scbc__tab-button.active {\n  color: #2c3948;\n  font-weight: 500;\n}\n\n.scbc__tab-button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #f97316;\n}\n\n.scbc__tab-button.inactive,\n.scbc__tab-button.disabled {\n  color: #a1a1aa;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.scbc__tab-button.inactive::after,\n.scbc__tab-button.disabled::after {\n  display: none;\n}\n\n.scbc__tab-button.inactive::before,\n.scbc__tab-button.disabled::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 5px;\n  padding: 5px 10px;\n  background-color: #333333;\n  color: #ffffff;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s, visibility 0.3s;\n  pointer-events: none;\n  z-index: 100;\n}\n\n.scbc__tab-button.inactive:hover::before,\n.scbc__tab-button.disabled:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* --- Onglets non implementes ---------------------------------------------- */\n.scbc__placeholder {\n  padding: 2rem;\n  font-size: 1.6rem;\n  color: #6b7280;\n}\n\n/* Accordeons de section : corps colle aux bords, scope a la case v2 uniquement\n   (ne touche pas le composant partage AnalyseAccordion utilise par MS). */\n.scbc .analyse-accordion-body {\n  padding: 0;\n}\n\n/* Pas de vide en bas : le dernier element du corps colle au bord de l'accordeon. */\n.scbc .analyse-accordion-body > *:last-child,\n.scbc .analyse-accordion-body .section-content > *:last-child {\n  margin-bottom: 0;\n}\n\n/* Table financiere : on garde le layout auto d'origine (les largeurs .article-*\n   en % restent respectees, colonnes alignees, hauteurs normales). On absorbe\n   juste le leger debordement (paddings des cellules) en masquant la scrollbar\n   horizontale residuelle, et on laisse un code trop long casser plutot que\n   d'etre coupe. Scope a la case v2. */\n.scbc .articles-table-wrapper {\n  overflow-x: hidden;\n}\n\n.scbc .articles-table-wrapper th,\n.scbc .articles-table-wrapper td {\n  overflow-wrap: break-word;\n}\n\n/* Alignement coherent en-tete + contenu, force par colonne : les MEMES regles\n   s'appliquent au thead et au tbody, donc l'en-tete ne peut pas se desynchroniser\n   du contenu, et ca surclasse la regle globale qui forcait les en-tetes a gauche.\n   Vaut pour la table read-only (6 colonnes) comme editable (7 colonnes, +Actions).\n   col1 N°Ref + col2 Description = gauche ; col3 Unite + col4 Quantite + col7\n   Actions = centre ; col5 Prix + col6 Total = droite. */\n.scbc .articles-table-wrapper th:nth-child(1),\n.scbc .articles-table-wrapper td:nth-child(1),\n.scbc .articles-table-wrapper th:nth-child(2),\n.scbc .articles-table-wrapper td:nth-child(2) {\n  text-align: left;\n}\n\n.scbc .articles-table-wrapper th:nth-child(3),\n.scbc .articles-table-wrapper td:nth-child(3),\n.scbc .articles-table-wrapper th:nth-child(4),\n.scbc .articles-table-wrapper td:nth-child(4),\n.scbc .articles-table-wrapper th:nth-child(7),\n.scbc .articles-table-wrapper td:nth-child(7) {\n  text-align: center;\n}\n\n.scbc .articles-table-wrapper th:nth-child(5),\n.scbc .articles-table-wrapper td:nth-child(5),\n.scbc .articles-table-wrapper th:nth-child(6),\n.scbc .articles-table-wrapper td:nth-child(6) {\n  text-align: right;\n  padding-right: 1rem;\n}\n\n/* Le bouton supprimer suit l'alignement centre de sa cellule (pas de flottant). */\n.scbc .articles-table-wrapper td:nth-child(7) .delete-button {\n  float: none;\n  margin: 0 auto;\n}\n\n/* Spinner de suppression : remplace la croix, meme taille (1em) et meme couleur. */\n.scbc .delete-spinner {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: scbc-delete-spin 0.6s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes scbc-delete-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Bouton \"Ajouter ou modifier un article\" : ne deborde plus a droite du wrapper\n   (il porte une marge de 1rem de chaque cote -> largeur bornee a 100% - 2rem). */\n.scbc .articles-table-wrapper .add-article-button {\n  box-sizing: border-box;\n  max-width: calc(100% - 2rem);\n}\n\n/* =============================================================================\n   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .scbc-sk, geometrie\n   calee sur le vrai rendu (banniere SuiviHeader + onglets + contenu) pour eviter le saut.\n   ============================================================================= */\n@keyframes scbc-sk-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.scbc-skeleton {\n  pointer-events: none;\n}\n\n.scbc-sk {\n  display: block;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: scbc-sk-shimmer 1.4s ease-in-out infinite;\n  border-radius: 6px;\n}\n\n/* Banniere : meme geometrie que SuiviHeader (.suivi-commande-title : padding 2rem 4rem,\n   marge basse 2rem, fond sombre) pour une hauteur identique au vrai header. */\n.scbc-sk-banner {\n  padding: 2rem 4rem;\n  margin-bottom: 2rem;\n  background: #1f2937;\n}\n\n/* Sur fond sombre, les blocs shimmer sont clairs. */\n.scbc-sk-banner .scbc-sk {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);\n  background-size: 200% 100%;\n}\n\n.scbc-sk-back { padding: 1rem 0; }\n.scbc-sk-back .scbc-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }\n\n.scbc-sk-h1 { height: 4.1rem; display: flex; align-items: center; }\n.scbc-sk-h1 .scbc-sk { width: 45%; height: 2.4rem; }\n\n.scbc-sk-h2 { height: 3.1rem; display: flex; align-items: center; }\n.scbc-sk-h2 .scbc-sk { width: 32%; height: 1.8rem; }\n\n.scbc-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }\n.scbc-sk-subtitle .scbc-sk { width: 38%; height: 1.4rem; }\n\n.scbc-sk-statusline { height: 2rem; display: flex; align-items: center; }\n.scbc-sk-statusline .scbc-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }\n\n/* Barre d'onglets : mime .scbc__tab-nav (border-bottom, marge basse 3rem). */\n.scbc-sk-tabs {\n  display: flex;\n  gap: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1rem 0;\n  margin-bottom: 3rem;\n}\n.scbc-sk-tab { width: 80px; height: 1.6rem; }\n\n/* Contenu : empilement de blocs (le padding horizontal/vertical vient de .scbc__tab-content). */\n.scbc-sk-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n.scbc-sk-block { width: 100%; height: 90px; }\n.scbc-sk-block--lg { height: 220px; }\n\n/* Badge de messages non-lus (onglet Messagerie). Pastille orange compacte collee au libelle. */\n.scbc__tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.8rem;\n  height: 1.8rem;\n  margin-left: 0.6rem;\n  padding: 0 0.5rem;\n  border-radius: 999px;\n  background-color: #f97316;\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  line-height: 1;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
